import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'sr:conditions',
    content: {
      segments: [
        {
          alias: 'terms',
          name: 'Terms',
          root: {
            elements: [
              {
                height: 800,
                content: {
                  widget: {
                    widget: {
                      alias: 'sr.conditions.widgets.terms-table',
                    },
                  },
                },
              },
            ],
          },
        },
        {
          alias: 'monitoring-activities',
          name: 'Monitoring Activities',
          root: {
            elements: [
              {
                height: 800,
                content: {
                  widget: {
                    widget: {
                      alias: 'sr.conditions.widgets.activities-table',
                    },
                  },
                },
              },
            ],
          },
        },
      ],
      navigator: core.mosaic.Page.Segment.Navigator.Tabs,
    },
    description: 'Conditions',
    name: 'Conditions',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
